"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserRequest = instanceOfUserRequest;
exports.UserRequestFromJSON = UserRequestFromJSON;
exports.UserRequestFromJSONTyped = UserRequestFromJSONTyped;
exports.UserRequestToJSON = UserRequestToJSON;
exports.UserRequestToJSONTyped = UserRequestToJSONTyped;
/**
 * Check if a given object implements the UserRequest interface.
 */
function instanceOfUserRequest(value) {
    if (!('username' in value) || value['username'] === undefined)
        return false;
    return true;
}
function UserRequestFromJSON(json) {
    return UserRequestFromJSONTyped(json, false);
}
function UserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'],
    };
}
function UserRequestToJSON(json) {
    return UserRequestToJSONTyped(json, false);
}
function UserRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
    };
}
//# sourceMappingURL=userRequest.js.map